module.exports = require("serve-static");


//////////////////
// WEBPACK FOOTER
// external "serve-static"
// module id = 23
// module chunks = 0